import { render, staticRenderFns } from "./RegisterValidate.vue?vue&type=template&id=a2c8db02&scoped=true&"
import script from "./RegisterValidate.vue?vue&type=script&lang=js&"
export * from "./RegisterValidate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterValidate.vue?vue&type=style&index=0&id=a2c8db02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c8db02",
  null
  
)

export default component.exports